<template>
    <div class="" v-if="appear" @click="flip = !flip">
        <transition name="flip" mode="out-in">
            <figure v-if="flip" class="bg-white shadow-md flex flex-col justify-center w-full h-full" key="front">
                <svg class="outlineAnimation" viewBox="0 0 47.88 31.5">
                    <g id="1f5a69b3-67da-452b-a470-a5f3ae7d718f" data-name="Layer 2">
                        <g id="20e15e8a-980c-4aec-af29-489bc43414ae" data-name="Layer 1">
                            <path d="M26.25,25.25h-25a1,1,0,0,1-1-1v-23a1,1,0,0,1,1-1h34a1,1,0,0,1,1,1v11"
                                  fill="none" stroke="#B81F76" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <path d="M26.25,25.25h-25a1,1,0,0,1-1-1v-2h26" fill="none" stroke="#B81F76"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <polyline
                                    points="16.36 29.25 12.25 29.25 12.25 30.25 24.25 30.25 24.25 29.25 22.25 29.25 21.25 25.25 15.25 25.25 14.25 29.25"
                                    fill="none" stroke="#B81F76" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <path d="M35.63,30.25H27.25a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v11.5"
                                  fill="none" stroke="#B81F76" stroke-miterlimit="10" stroke-width="0.5"/>
                            <line x1="35.63" y1="28.75" x2="26.25" y2="28.75" fill="none" stroke="#B81F76"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <rect x="38.38" y="22" width="6.5" height="12" rx="0.96" ry="0.96"
                                  transform="translate(69.63 -13.63) rotate(90)" fill="none" stroke="#B81F76"
                                  stroke-miterlimit="10" stroke-width="0.5"/>
                            <line x1="37.25" y1="24.75" x2="37.25" y2="29.75" fill="none" stroke="#B81F76"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <polyline
                                    points="11.7 16.38 23.23 4.86 24.64 6.27 12.62 18.29 9.79 19.7 11.21 16.88 12.06 17.73"
                                    fill="none" stroke="#B81F76" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <rect x="23.79" y="4.21" width="1" height="2"
                                  transform="translate(3.43 18.7) rotate(-45)" stroke="#B81F76" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M24.28,3h1.5a1,1,0,0,1,1,1V4a1,1,0,0,1-1,1h-1.5a0,0,0,0,1,0,0V3A0,0,0,0,1,24.28,3Z"
                                  transform="translate(4.67 19.21) rotate(-45)" fill="none" stroke="#B81F76"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
                <h1 class="font-hairline text-xl text-center mt-6">Webdesign</h1>
            </figure>
            <figure v-else class="shadow-md card flex flex-col justify-center w-full h-full bg-v-magenta" key="back">
                <span class="font-light xl:font-hairline font-fira text-white leading-normal p-8">Aktuális trendeket követő, felhasználóbarát  design elsősorban vállalkozások és cégek weboldalaira. Modern arculat tervezés a hatékony ügyfélszerzésért. Reszponzív kivitelezés.
                    </span>
            </figure>
        </transition>
    </div>
</template>

<script>
export default {
  props: ['svg', 'appear'],
  data () {
    return {
      flip: true
    }
  }
}

</script>

<style lang="scss" scoped>
    .outlineAnimation {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        animation: icon-animate-in 2s cubic-bezier(0.95, 0.05, 0.795, 0.035);
    }
    @keyframes icon-animate-in {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
    figure {
        border-radius: 10px;
    }

    svg {
        height: 5rem;
        fill: #B81F76;
    }
    .flip-enter-active, .flip-leave-active {
        transition: all .2s ease-in;
    }

    .flip-enter, .flip-leave-to {
        transform: rotateY(90deg);
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Webdesign.vue